function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// state values for layer loading statuses
var STATE = {
  ERROR: 'error',
  SUCCESS: 'success'
};

/**
 * @class Oskari.pti.layerstatus.StatusBundleInstance
 */
Oskari.clazz.define('Oskari.layeranalytics.StatusBundleInstance', function () {
  // no-op
}, {
  __name: 'LayerStatusBundleInstance',
  __loadingStatus: {},
  _startImpl: function _startImpl(sandbox) {
    var _this = this;
    var map = sandbox.findRegisteredModuleInstance('MainMapModule');
    map.on('layer.loading', function (event) {
      // event: {layer: 801, started: true, errored: false}
      if (event.started) {
        // don't care about start events
        return;
      }
      _this._handleLoadingEvent(event.layer, event.errored);
    });
    window.addEventListener('beforeunload', function () {
      // just fire and forget when the user leaves the page
      _this._sendStatus();
    });
  },
  _handleLoadingEvent: function _handleLoadingEvent(layer, wasError) {
    var stats = this._getLayerStatus(layer);
    var currentState = STATE.SUCCESS;
    if (wasError) {
      stats.errors++;
      currentState = STATE.ERROR;
    } else {
      stats.success++;
    }
    if (stats.previous !== currentState) {
      stats.previous = currentState;
      // for the first 10 state changes:
      // save stack for current state with center coord and zoom level
      if (stats.stack.length < 10) {
        var mapState = this.sandbox.getMap();
        stats.stack.push({
          x: mapState.getX(),
          y: mapState.getY(),
          z: mapState.getZoom(),
          state: currentState,
          layers: mapState.getLayers().map(function (l) {
            return l.getId();
          })
        });
      }
    }
  },
  _getLayerStatus: function _getLayerStatus(layerId) {
    var includeVector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var NON_TRACKED_LAYER = 'runtimeVector';
    if (!layerId) {
      var status = _objectSpread({}, this.__loadingStatus);
      if (!includeVector) {
        delete status[NON_TRACKED_LAYER];
      }
      return status;
    }
    var id = '' + layerId;
    // combine results for recognized layer ids from same (internal) service
    if (typeof layerId !== 'number') {
      if (id.startsWith('myplaces_') || id.startsWith('userlayer_') || id.startsWith('analysis_')) {
        id = 'usercontent';
      } else {
        // STATS_LAYER and other runtime vector layers
        id = NON_TRACKED_LAYER;
      }
    }
    var stats = this.__loadingStatus[id];
    if (stats) {
      return stats;
    }
    this.__loadingStatus[id] = {
      errors: 0,
      success: 0,
      stack: [],
      previous: STATE.SUCCESS
    };
    return this.__loadingStatus[id];
  },
  _sendStatus: function _sendStatus() {
    fetch(Oskari.urls.getRoute('LayerStatus'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this._getLayerStatus())
    });
  }
}, {
  extend: ['Oskari.BasicBundle'],
  protocol: ['Oskari.bundle.BundleInstance', 'Oskari.mapframework.module.Module']
});